import CandidateCard from './CandidateCard';
import type { CustomField } from '../../custom_categories/hooks/useCustomFields';
import type {
  AgentApiCandidateProfilesItem,
  AgentApiCandidateProfilesBoard,
} from '@/types/serializers';
import type { ActiveUser } from '../../types/ActiveUser';

interface Props {
  customFields: CustomField[];
  candidateProfiles: AgentApiCandidateProfilesItem[];
  activeUsers: ActiveUser[];
  currentUserId?: number;
  onUpdateAssignees: (candidateProfileId: number, userIds: number[]) => void;
  candidatesBoards: AgentApiCandidateProfilesBoard[];
  onBoardChanged: () => void;
  selectedIds: Set<number>;
  onCheckedChange: (id: number, checked: boolean) => void;
}

export default function Results({
  customFields,
  candidateProfiles,
  activeUsers,
  currentUserId,
  onUpdateAssignees,
  candidatesBoards,
  onBoardChanged,
  selectedIds,
  onCheckedChange,
}: Props) {
  return (
    <div className="flex flex-col gap-md">
      {candidateProfiles.map((p) => (
        <CandidateCard
          key={p.id}
          customFields={customFields}
          activeUsers={activeUsers}
          currentUserId={currentUserId}
          onUpdateAssignees={onUpdateAssignees}
          candidatesBoards={candidatesBoards}
          onBoardChanged={onBoardChanged}
          isChecked={selectedIds.has(p.id)}
          onCheckedChange={(checked) => onCheckedChange(p.id, checked)}
          {...p}
        />
      ))}
    </div>
  );
}
